import { CARE_EXPLICIT_TIME_PATTERN, normalizeCareTimeCandidate } from './careDateTimePatterns';

export const getCareClockEvidence = (text = '') => {
  const source = String(text || '');
  const pattern = new RegExp(`\\b${CARE_EXPLICIT_TIME_PATTERN}\\b`, 'gi');
  const clocks = [...source.matchAll(pattern)].map((match) => {
    return normalizeCareTimeCandidate(match[0]) || match[0].toLowerCase();
  });
  return {
    multiple: new Set(clocks).size > 1
      || /\b(?:at|around|about)\s+\d{1,2}(?::\d{2})?(?:\s*[ap]\.?m\.?)?(?:\s*,\s*|\s+and\s+)\d{1,2}(?::\d{2})?/i.test(source),
    ambiguous: /\b(?:at|around|about)\s+\d{1,2}(?:[:.]\d{2})?(?:\s+o['’]?clock)?\b(?!\s*[ap]\.?m\.?)/i.test(source)
      && clocks.length === 0,
  };
};
